module.exports = __webpack_public_path__ + "img/cog-white.bcf4251d.svg";